import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';


// branch list
export const fetchBranchListRequest = () => ({
    type: "FIND_BRANCH_LIST_REQUEST",
});

export const fetchBranchListSuccess = (data) => ({
    type: "FIND_BRANCH_LIST_SUCCESS",
    payload: data,
});

export const fetchBranchListFailure = (error) => ({
    type: "FIND_BRANCH_LIST_FAILURE",
    payload: error,
});

export const getBranchList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchBranchListRequest());
        // const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;
        const body = { customer_id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchList function (redux):", err);
                dispatch(fetchBranchListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchList function:", error);
            dispatch(fetchBranchListFailure(error));
        }
    };
};

// branch list

// organsation view
export const fetchBranchDetailRequest = () => ({
    type: "FIND_BRANCH_DETAIL_REQUEST",
});

export const fetchBranchDetailSuccess = (data) => ({
    type: "FIND_BRANCH_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBranchDetailFailure = (error) => ({
    type: "FIND_BRANCH_DETAIL_FAILURE",
    payload: error,
});

export const getBranchDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchBranchDetailRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/view`;
        const body = { id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchDetail function (redux):", err);
                dispatch(fetchBranchDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchDetail function:", error);
            dispatch(fetchBranchDetailFailure(error));
        }
    };
};

// organsation view

// branch custom view
export const fetchBranchCustomDetailRequest = () => ({
    type: "FIND_BRANCH_CUSTOM_DETAIL_REQUEST",
});

export const fetchBranchCustomDetailSuccess = (data) => ({
    type: "FIND_BRANCH_CUSTOM_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBranchCustomDetailFailure = (error) => ({
    type: "FIND_BRANCH_CUSTOM_DETAIL_FAILURE",
    payload: error,
});

export const getBranchCustomDetail = (token, user_id, branch_id, customer_id) => {
    return async function (dispatch) {
        dispatch(fetchBranchCustomDetailRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/custom_detail/get`;
        const body = { general_branch_id: branch_id, customer_id: customer_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchCustomDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchCustomDetail function (redux):", err);
                dispatch(fetchBranchCustomDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchCustomDetail function:", error);
            dispatch(fetchBranchCustomDetailFailure(error));
        }
    };
};

// branch custom view


// branch custom bank list
export const fetchBranchCustomBankListRequest = () => ({
    type: "FIND_BRANCH_CUSTOM_BANK_LIST_REQUEST",
});

export const fetchBranchCustomBankListSuccess = (data) => ({
    type: "FIND_BRANCH_CUSTOM_BANK_LIST_SUCCESS",
    payload: data,
});

export const fetchBranchCustomBankListFailure = (error) => ({
    type: "FIND_BRANCH_CUSTOM_BANK_LIST_FAILURE",
    payload: error,
});

export const getBranchCustomBankList = (token, user_id, branch_id, customer_id) => {
    return async function (dispatch) {
        dispatch(fetchBranchCustomBankListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/custom_detail/bank/list`;
        const body = { general_branch_id: branch_id, customer_id: customer_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchCustomBankListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchCustomBankList function (redux):", err);
                dispatch(fetchBranchCustomBankListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchCustomBankList function:", error);
            dispatch(fetchBranchCustomBankListFailure(error));
        }
    };
};

// branch custom bank list

// branch custom bank detail
export const fetchBranchCustomBankDetailRequest = () => ({
    type: "FIND_BRANCH_CUSTOM_BANK_DETAIL_REQUEST",
});

export const fetchBranchCustomBankDetailSuccess = (data) => ({
    type: "FIND_BRANCH_CUSTOM_BANK_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBranchCustomBankDetailFailure = (error) => ({
    type: "FIND_BRANCH_CUSTOM_BANK_DETAIL_FAILURE",
    payload: error,
});

export const getBranchCustomBankDetail = (token, user_id, branch_id, customer_id) => {
    return async function (dispatch) {
        dispatch(fetchBranchCustomBankDetailRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/custom_detail/get`;
        const body = { general_branch_id: branch_id, customer_id: customer_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchCustomBankDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchCustomBankDetail function (redux):", err);
                dispatch(fetchBranchCustomBankDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchCustomBankDetail function:", error);
            dispatch(fetchBranchCustomBankDetailFailure(error));
        }
    };
};

// branch custom bank detail


//branch country
export const fetchBranchCountryRequest = () => ({
    type: "FIND_BRANCH_COUNTRY_REQUEST",
});

export const fetchBranchCountrySuccess = (data) => ({
    type: "FIND_BRANCH_COUNTRY_SUCCESS",
    payload: data,
});

export const fetchBranchCountryFailure = (error) => ({
    type: "FIND_BRANCH_COUNTRY_FAILURE",
    payload: error,
});

export const getBranchCountry = () => {
    return async function (dispatch) {
        dispatch(fetchBranchCountryRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/country/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchBranchCountrySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getBranchCountry function(redux):", err);
            });
    };
};
//branch country

// branch state
export const fetchBranchStateRequest = () => ({
    type: "FIND_BRANCH_STATE_REQUEST",
});

export const fetchBranchStateSuccess = (data) => ({
    type: "FIND_BRANCH_STATE_SUCCESS",
    payload: data,
});

export const fetchBranchStateFailure = (error) => ({
    type: "FIND_BRANCH_STATE_FAILURE",
    payload: error,
});

export const getBranchState = (id) => {
    return async function (dispatch) {
        dispatch(fetchBranchStateRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/state/list?country_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchBranchStateSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getBranchState function(redux):", err);
            });
    };
};

// branch state

// branch city
export const fetchBranchCityRequest = () => ({
    type: "FIND_BRANCH_CITY_REQUEST",
});

export const fetchBranchCitySuccess = (data) => ({
    type: "FIND_BRANCH_CITY_SUCCESS",
    payload: data,
});

export const fetchBranchCityFailure = (error) => ({
    type: "FIND_BRANCH_CITY_FAILURE",
    payload: error,
});

export const getBranchCity = (id) => {
    return async function (dispatch) {
        dispatch(fetchBranchCityRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/city/list?state_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchBranchCitySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getBranchCity function(redux):", err);
            });
    };
};

// branch city


//branch airport
export const fetchBranchAirportRequest = () => ({
    type: "FIND_BRANCH_AIRPORT_REQUEST",
});

export const fetchBranchAirportSuccess = (data) => ({
    type: "FIND_BRANCH_AIRPORT_SUCCESS",
    payload: data,
});

export const fetchBranchAirportFailure = (error) => ({
    type: "FIND_BRANCH_AIRPORT_FAILURE",
    payload: error,
});

export const getBranchAirport = () => {
    return async function (dispatch) {
        dispatch(fetchBranchAirportRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/airport/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchBranchAirportSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getBranchAirport function(redux):", err);
            });
    };
};
//branch airport


//branch seaport
export const fetchBranchSeaportRequest = () => ({
    type: "FIND_BRANCH_SEAPORT_REQUEST",
});

export const fetchBranchSeaportSuccess = (data) => ({
    type: "FIND_BRANCH_SEAPORT_SUCCESS",
    payload: data,
});

export const fetchBranchSeaportFailure = (error) => ({
    type: "FIND_BRANCH_SEAPORT_FAILURE",
    payload: error,
});

export const getBranchSeaport = () => {
    return async function (dispatch) {
        dispatch(fetchBranchSeaportRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/seaport/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchBranchSeaportSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getBranchSeaport function(redux):", err);
            });
    };
};
//branch seaport


//<------------------------------------MORE ADDRESS ------------------------------------->
// branch more address list
export const fetchBranchMoreAddressListRequest = () => ({
    type: "FIND_BRANCH_MORE_ADDRESS_LIST_REQUEST",
});

export const fetchBranchMoreAddressListSuccess = (data) => ({
    type: "FIND_BRANCH_MORE_ADDRESS_LIST_SUCCESS",
    payload: data,
});

export const fetchBranchMoreAddressListFailure = (error) => ({
    type: "FIND_BRANCH_MORE_ADDRESS_LIST_FAILURE",
    payload: error,
});

export const getBranchMoreAddressList = (token, user_id, branch_id, customer_id) => {
    return async function (dispatch) {
        dispatch(fetchBranchMoreAddressListRequest());
        // const token = Cookies.get('token');
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/address/list`;
        const body = { customer_id: customer_id, general_branch_id: branch_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchMoreAddressListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchMoreAddressList function (redux):", err);
                dispatch(fetchBranchMoreAddressListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchMoreAddressList function:", error);
            dispatch(fetchBranchMoreAddressListFailure(error));
        }
    };
};

// branch more address list


// branch more address view
export const fetchBranchMoreAddressDetailRequest = () => ({
    type: "FIND_BRANCH_MORE_ADDRESS_DETAIL_REQUEST",
});

export const fetchBranchMoreAddressDetailSuccess = (data) => ({
    type: "FIND_BRANCH_MORE_ADDRESS_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBranchMoreAddressDetailFailure = (error) => ({
    type: "FIND_BRANCH_MORE_ADDRESS_DETAIL_FAILURE",
    payload: error,
});

export const getBranchMoreAddressDetail = (token, user_id, customer_id, branch_id, id) => {
    return async function (dispatch) {
        dispatch(fetchBranchMoreAddressDetailRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/address/view`;
        const body = { id: id, customer_id: customer_id, general_branch_id: branch_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchMoreAddressDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchMoreAddressDetail function (redux):", err);
                dispatch(fetchBranchMoreAddressDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchMoreAddressDetail function:", error);
            dispatch(fetchBranchMoreAddressDetailFailure(error));
        }
    };
};

// branch more address view



//Account managers
export const fetchAccountManagersRequest = () => ({
    type: "FIND_ACCOUNT_MANAGER_REQUEST",
});

export const fetchAccountManagersSuccess = (data) => ({
    type: "FIND_ACCOUNT_MANAGER_SUCCESS",
    payload: data,
});

export const fetchAccountManagersFailure = (error) => ({
    type: "FIND_ACCOUNT_MANAGER_FAILURE",
    payload: error,
});

export const getAccountManagers = () => {
    return async function (dispatch) {
        dispatch(fetchAccountManagersRequest());
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/employee-list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAccountManagersSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getAccountManagers function(redux):", err);
            });
    };
};
//Account managers


//Account managers
export const fetchBranchAccountManagerDetailRequest = () => ({
    type: "FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_REQUEST",
});

export const fetchBranchAccountManagerDetailSuccess = (data) => ({
    type: "FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBranchAccountManagerDetailFailure = (error) => ({
    type: "FIND_BRANCH_ACCOUNT_MANAGER_DETAIL_FAILURE",
    payload: error,
});

export const getBranchAccountManagerDetail = (branch_id, token, user_id, customer_id) => {
    return async function (dispatch) {
        dispatch(fetchBranchAccountManagerDetailRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/account_manager/details`;
        const body = { customer_id: customer_id, general_branch_id: branch_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchBranchAccountManagerDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getBranchAccountManagerDetail function (redux):", err);
                dispatch(fetchBranchAccountManagerDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getBranchAccountManagerDetail function:", error);
            dispatch(fetchBranchAccountManagerDetailFailure(error));
        }
    };
};
//Account managers